module.exports = {
  days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  weekStart: 0,
  meridiem: ['AM', 'PM'],
  mostCurrent: 'Most Current',
};